import React, { useState } from 'react';
import { WbEventHandlerMixins, WbMarkdownHtml,isReadOnlyUserLicenseType  } from "../utils/common";
import { withTranslation } from 'react-i18next';
import { hot } from "react-hot-loader/root";
import { KeyDownEvent, KeyDownEventLink } from '../utils/eventKey';
import { ThemeProvider, Modal } from '@workboard/wobo-ui';
import { metricProgressColor } from '../utils/metricProgressColor';
import { KrUpdateModalManager, useUpdateModalActions } from '@workboard/ui-okr';

let clickEventCount = 0;
/**
 * show email popup
 */
function showEmailPopup() {
  $(".send-email-popup").show();
}

/**
 * unique array.
 * @param {*} array
 */
function uniqueArray(array) {
  return [...new Set(array)];
}

/**
 * send email data.
 * @param {*} ele
 * @param {*} params
 */
function sendEmailPopupData (ele, params, url, setOpen) {
  const obj = $(`#${ele}`);
  if ($(obj).hasClass('processing')) {
    return false;
  }
  var emails = $('.send-email-popup-comp input[name="emails"]').val();
  const subject = $('.send-email-popup-comp input[name="subject"]').val();
  $('.send-via-email-errors').hide();
  if (emails == '' || emails == null) {
    $('.send-via-email-errors')
      .show()
      .html('please enter the email address');
      $(".wobo-ui-email-input-wrapper").css("border", "solid 1px #F04A43");
    return false;
  }
  var emails = emails.split(/[,]+/); // split element by ,
  for (const i in emails) {
    const value = $.trim(emails[i]);
    if (
      !/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-+]+)*@[A-Za-z0-9-]+(\.[a-z0-9-]+)*(\.[A-Za-z]{2,20})$/.test(
        value
      )
    ) {
      $('.send-via-email-errors')
        .show()
        .html('please enter the valid email address');
      $(".wobo-ui-email-input-wrapper").css("border", "solid 1px #F04A43");
      return false;
    }
  }
  if (typeof url === 'undefined' || url == '') {
    return false;
  }
  let data = { users: emails, subject };
  if (typeof params === 'object') {
    data = Object.assign(data, params);
  }
  $(obj).addClass('processing');
  $.ajax({
    url,
    type: 'POST',
    data
  })
    .done((response) => {
      $(obj).removeClass('processing');
      if (response.error) {
        $('.send-via-email-errors')
          .show()
          .html(response.error);
        $(".wobo-ui-email-input-wrapper").css("border", "solid 1px #F04A43");
      } else {
        let text = ' &nbsp;&nbsp;&nbsp;Email successfully sent.';
        if (typeof response.notSendMail !== 'undefined') {
          text = ` &nbsp;&nbsp;&nbsp;Not allowed to email goals outside the organization.(${response.notSendMail})`;
        }

        infoPopup.call(text, 5000);
        $('.send-email-popup-comp input[name="emails"]').val('');
        $('.send-email-popup-comp input[name="subject"]').val('');
        setOpen(false);
      }
    })
    .fail(() => {
      $(obj).removeClass('processing');
    });
}

/**
 * @component EmailPopupComp
 * @param {*} param0
 */
const EmailPopupComp = ({ data, open, setOpen, t }) => {
  const url = typeof data.url !== 'undefined' ? data.url : '';
  const params = {};
  params.id = data.id;
  params.parentMetricId = data.parentMetricId;
  return (
    <ThemeProvider>
      <Modal
        disableScrollLock
        id="email-publish-container"
        isOpen={open}
        onDismiss={() => setOpen(false)}
        onSubmit={() => {
          sendEmailPopupData('send-email-btn-comp', params, url, setOpen)
        }}
        style={{ backgroundColor: 'rgba(170,170,170, 0.3) !important' }}
        submitLabel="Send"
        title="Send via email"
      >
        <div className="send-email-popup-comp">
        <div className="send-via-email-errors" role="alert" aria-live="polite" />
        <div className="wobo-ui-textfield">
          <label htmlFor="send-via-email-title" className="send-via-title wobo-ui-textfield-label" style={{color:"#333943"}}>
            Enter an email address (separate multiple emails by commas)
          </label>
          <div className="wobo-ui-textfield-input-wrapper wobo-ui-email-input-wrapper">
            <input
              className="send-email-textbox wobo-ui-textfield-input"
              id="send-via-email-title"
              name="emails"
              placeholder="Enter one or more email addresses separated by commas"
              type="text"
            />
          </div>
        </div>
        <div className="wobo-ui-textfield" style={{marginTop: "8px"}}>
          <label htmlFor="send-via-email-subject" className="send-via-title wobo-ui-textfield-label" style={{color:"#333943"}}>{t('Subject')}</label>
          <div className="wobo-ui-textfield-input-wrapper">
            <input
              className="send-email-textbox wobo-ui-textfield-input"
              id="send-via-email-subject"
              name="subject"
              placeholder="Progress report"
              type="text"
            />
          </div>
        </div>
      </div>
      </Modal>
    </ThemeProvider>
  );
};

/**
 * showSlackPopup
 */
function showSlackPopup(sUrl) {
  showLoader($(".contentTd2 #content"));
  publishingReportsInExternalSystem(sUrl);
}
/**
 * @component SlackPopupComp
 * @param {*} props
 */
const SlackPopupComp = ({ url, id, type }) => (
  <div className="slack-publish-popup">
    <div className="goal-table-tmp">
      <div className="goal-table-row-tmp">
        <div className="goal-table-col slack-team-title">
          Slack Team: <span id="slack-team-name" style={{ fontWeight: 600 }} />
        </div>
        <div className="goal-table-col">
          <div
            onClick={() => publishSlackData(url, id, type)}
            className="gbl-btn gbl-btn-slim"
            style={{ height: "30px !important", paddingTop: "5px !important" }}
          >
            Publish
          </div>
        </div>
      </div>
    </div>
    <div
      id="slack-list"
      className="goal-table-tmp verticalScroll fixed-height"
    />
  </div>
);

/**
 * publish slack data.
 * @param {*} url
 */
function publishSlackData(url, id, type) {
  if (typeof url === "undefined") {
    return;
  }
  const slackIds = [];
  $(".slack-ids-ims").each(function(index, value) {
    if ($(this).is(":checked")) {
      slackIds.push($(this).val());
    }
  });
  const formData = { appId: 1, slack_ids: slackIds };
  if (type == "KR_Data_Result") {
    formData.metricId = id;
  }
  $.post(url, formData, data => {
    infoPopup.call(" &nbsp;&nbsp;&nbsp;Successfully published in Slack.");
    $(".slack-publish-popup").hide();
  });
}

/**
 * @component WbLikesComp
 */
class WbLikesComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item,
      users:
        typeof this.props.item.likes !== "undefined"
          ? this.props.item.likes
          : []
    };
    this.wbLikesHanlder = this.wbLikesHanlder.bind(this);
    this.saveLikes = this.saveLikes.bind(this);
    this.likesContent = this.likesContent.bind(this);
  }

  /**
   * trigger likes handler
   * @param {*} item
   */
  wbLikesHanlder(item, isPrintPage) {
    if (isPrintPage) {
      return;
    }
    const _this = this;
    const type =
      typeof item.source_type !== "undefined" ? item.source_type : "";
    clickEventCount++;
    let clickEventIntervalID;
    if (clickEventCount === 1) {
      clickEventIntervalID = setTimeout(() => {
        clickEventCount = 0;
        _this.saveLikes({ id: item.id, type });
      }, 400);
    } else if (clickEventCount === 2) {
      clearTimeout(clickEventIntervalID);
      clickEventCount = 0;
      _this.saveLikes({ id: item.id, type });
    }
  }

  /**
   * save likes
   * @param {*} item
   */
  saveLikes(item) {
    console.log("saveLikes");
    const _this = this;
    let { users } = this.state;
    $.post(
      `${wbConfig.baseUrl}/likes/metricKeyComment`,
      { id: item.id, type: item.type },
      response => {
        const action =
          typeof response.action !== "undefined" ? response.action : "";
        if (action == "added") {
          users = users.filter(it => it.owner != response.userId);
          users.push({
            object_id: item.id,
            owner: response.userId,
            fullName: response.fullName
          });
          _this.setState({ users });
        } else if (action == "deleted") {
          users = users.filter(it => it.owner != response.userId);
          _this.setState({ users });
        } else {
          console.log("invalid parameters");
        }
      }
    );
  }

  likesContent(likeImg, likesLength = 0) {
    return (
      <div style={{ display: "inline" }}>
        <div className="wb-like-img">
          <img src={`${wbConfig.imageCdnUrl}/${likeImg}`} />
        </div>
        <div className="wb-like-count" data-count={likesLength}>
          {likesLength == "0" ? "" : likesLength}
        </div>
      </div>
    );
  }

  /**
   * render html.
   */
  render() {
    const { item } = this.state;
    const likesLength = this.state.users.length;
    const likeClass = likesLength ? " active " : "";
    let likeThemeStyles = {};
    const likeCountCharLength = likesLength.toString().length;
    if (likeCountCharLength > 2) {
      likeThemeStyles = { width: `${40 + (likeCountCharLength - 2) * 8}px` };
    }
    let likeImg = "images/icons/likes/like_hollow_plus.png";
    if (likesLength) {
      likeImg = "images/icons/likes/liked.png";
    }
    const isPrintPage =
      typeof this.props.store.fromSource !== "undefined" &&
      this.props.store.fromSource == "print"
        ? 1
        : 0;
    if (!isPrintPage && likesLength == 0) {
      likeThemeStyles.display = "none";
    }
    return (
      <div
        className={`wb-like-theme ${likeClass}`}
        style={likeThemeStyles}
        id={`wb-likes-theme-${item.id}`}
        onClick={() => this.wbLikesHanlder(item, isPrintPage)}
      >
        {!isPrintPage
          ? this.likesContent(likeImg, likesLength)
          : likesLength
          ? this.likesContent(likeImg, likesLength)
          : ""}
        {likesLength && !isPrintPage ? (
          <div className="likes-user-list">
            {this.state.users.map((item, index) => (
              <div className="like-user" key={`like_user_${index}`}>
                {item.fullName}
              </div>
            ))}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

/**
 * @component MetricDataListComp
 * @param {*} param0
 */
const MetricDataListComp = ({
  data,
  nested = 0,
  handlers = {},
  store = {},
  source,
  t
}) => {
  const dataLength = data.length || 0;
  if (!dataLength) return;
  let header = "";
  if (!nested) {
    header = (
      <div className="view-table-row view-table-header-row">
        <div className="view-table-col metric-data-date-col">{t("Date")}</div>
        <div className="view-table-col metric-data-value-col">{t("Update")}</div>
        <div className="view-table-col metric-data-comment-col">{t("Narrative")}</div>
      </div>
    );
  }
  return (
    <ul className="view-table metric-result-data-table">
      {data.map((item, index) => (
        <li className="view-table-row" key={`view_metric_table_row_${index}`}>
          <div className="view-table-col metric-data-date-col">
            {item.create_at_text}
          </div>
          <div className="view-table-col metric-data-value-col">
            <span
              className={
                item.m_data == null || item.m_data === "" ? " nodata-value " : ""
              }
            >
              {source == "10"
                ? item.ds_data == null || item.ds_data === ""
                  ? "No Data"
                  : isNaN(item.ds_data) ? item.ds_data : (parseFloat(item.ds_data)).toFixed(2)
                : item.m_data == null || item.m_data === ""
                ? "No Data"
                : isNaN(item.m_data) ? item.m_data : (parseFloat(item.m_data)).toFixed(2)}
            </span>
          </div>
          <div className="view-table-col metric-data-comment-col">
            {item.comment ? (
              <div
                className="md-comment-text"
              >
                <div
                  dangerouslySetInnerHTML={WbMarkdownHtml(item.comment)}
                  style={{ display: "inline" }}
                />    
              </div>
            ) : (
              ""
            )}
            <div
              className="md-comment-author-wrapper"
              style={{ marginTop: item.comment ? 10 : 0 }}
            >
              {(item.updated_at > 0) && 
                  <>
                    {item.fullName}
                    <span className="dotClass" />
                  </>
              }
              {(item.updated_date?.length) && 
                  <>
                    {item.updated_date.substr(0,12)}<span className="dotClass" />{item.updated_date.substr(12)}
                  </>
              }
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

const KrUpdateButton = ({ item, t }) => {
  //const { t } = useTranslation();
  const { open } = useUpdateModalActions();

  const handleUpdate = () => {
    open({
      krId: item.id,
      source: item.source
    })
  }

  return (
    <button
      type="button"
      className="md-metric-update-link right clickable no-border-no-background"
      onClick={handleUpdate}
    >
      {t('Update')}
    </button>
  )
}

/**
 *@component MetricDataHeaderComp
 * @param {*} props
 */
const MetricDataHeaderComp = props => {
  const [emailOpen, setEmailOpen] = useState(false);
  const { t } = props;
  const item = props.data;
  const refSource = props.data.refSource;
  const isPrintPage =
    typeof props.store.fromSource !== "undefined" &&
    props.store.fromSource == "print"
      ? 1
      : 0;
  let showLogo = "";
  const { isSlackEnabled = false } = item;
  if (isPrintPage) {
    showLogo = (
      <div className="view-table-row">
        <div className="right">
          <img src={props.store.orgLogo} height="25" alt="" />
        </div>
      </div>
    );
  }
  const slackPublishUrlForThisKR = `/integration/publishKRDataResults?id=${item.id}&parentMetricId=${item.parentMetricId}`;
  
  const uploadFile = (file) => window.FUS.uploadFile(file)

  return (
    <div className="metric-data-header-wrapper">
      <div className="view-table" style={{ marginBottom: "25px" }}>
        <div className="view-table-row">
          <div className="view-table-col md-header-title-col">
            <div className="md-header-title" role='heading' aria-level='1'>
              {t('HISTORY AS OF')} {item.currentDate}
            </div>
          </div>
          {!isPrintPage && (
            <div className="view-table-col md-header-right-icons-col">
              <div className="right">
                {isSlackEnabled && (
                  <div className="md-header-icon">
                    <div className="md-header-slack">
                      <img
                        alt=""
                        aria-label="Share to Slack"
                        onClick={() => showSlackPopup(slackPublishUrlForThisKR)}
                        onKeyDown={(e) => KeyDownEvent(e, () => showSlackPopup(slackPublishUrlForThisKR))}
                        role="button"
                        src={`${wbConfig.imageCdnUrl}/images/logo/slack_logo.png`}
                        tabIndex="0"
                        width="15"
                      />
                    </div>
                  </div>
                )}
                <div className="md-header-icon">
                  <div className="md-header-email">
                    <img
                      alt=""
                      aria-label="Send via email"
                      title={t('Send via email')}
                      onClick={() => setEmailOpen(true)}
                      onKeyDown={(e) => KeyDownEvent(e, () => setEmailOpen(true))}
                      role="button"
                      src={`${wbConfig.imageCdnUrl}/images/icons/email.png`}
                      tabIndex="0"
                    />
                    <EmailPopupComp
                      data={{
                        url: `${wbConfig.baseUrl}/goal/sendMetricKeyResults`,
                        id: item.id,
                        parentMetricId: item.parentMetricId,
                      }}
                      open={emailOpen}
                      setOpen={setEmailOpen}
                      t={t}
                    />
                  </div>
                </div>
                <div className="md-header-icon">
                  <div className="md-header-print">
                    <img
                      width="15"
                      tabIndex="0"
                      role="link"
                      aria-label="print"
                      title={t('Print')}
                      onClick={() =>
                        window.open(
                          `${wbConfig.baseUrl}/goal/printMetricKeyResults?id=${item.id}&parentMetricId=${item.parentMetricId}`
                        )
                      }
                      onKeyDown={(e) =>KeyDownEventLink(e, ()=> 
                        window.open(
                          `${wbConfig.baseUrl}/goal/printMetricKeyResults?id=${item.id}&parentMetricId=${item.parentMetricId}`
                        )) 
                      }
                      src={`${wbConfig.imageCdnUrl}/images/icons/print.png`}
                    />
                  </div>
                </div>
                <div className="clear" />
              </div>
            </div>
          )}
        </div>
        {showLogo}
      </div>
      <div className="view-table">
        <div className="view-table-row">
          <div className="view-table-col md-metric-perc-col">
            <div className='screen-reader-only'>
              {`${metricProgressColor[item.metric_progress_color.toLowerCase()] ? metricProgressColor[item.metric_progress_color.toLowerCase()] : ''} ${item.achieve_target} ${item.targetDisplay ? `of ${item.total_target}` : ""}`}
            </div>

              <div
                className="md-metric-perc-t1"
                style={{ color: item.metric_progress_color }}
                aria-hidden="true"
              >
                {item.achieve_target}
              </div>
              
              {item.targetDisplay ? (
              <div 
                className="md-metric-perc-t2"
                aria-hidden='true'
                >
                {`of ${item.total_target}`}
              </div> 
            ) : (
              ""
            )}
          </div>
          <div className="view-table-col md-metric-objective-col">
            <div className="md-metric-objective-wrapper">
              <div className="md-metric-title" role='heading' aria-level='2'>{item.name}</div>
              <div className="md-metric-subtitle">
                {item.metricIntervalText}
              </div>
              <div className="md-metric-goal-title">
                <div className="md-metric-object">
                  <span style={{ color: '#666', marginRight: '5px' }}>
                  {t('For objective')}:
                  </span>
                  {item.goal}{" "}
                </div>
              </div>
              <div className="md-metric-goal-period-wrapper">
                <div className="md-metric-object md-metric-goal-period left">
                  <span style={{ color: '#666', marginRight: '5px' }}>
                    {t('For period')}:
                  </span>
                  {item.goalPeriodText}
                </div>
                {typeof item.canUpdate !== 'undefined' && item.canUpdate && !isReadOnlyUserLicenseType() && (
                  <KrUpdateModalManager mixpanelLocation="HISTORY_PAGE" mixpanelLocationDetail="HISTORY_PAGE" uploadFile={uploadFile}>
                    <KrUpdateButton item={item} t={t}/>
                  </KrUpdateModalManager>
                )}
                <div className="clear" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @component MetricKeyNestedGoalsComp
 * @param {*} param0
 */
const MetricKeyNestedGoalsComp = ({ data = [], nested = 0, handlers = {}, t }) => {
  const dataLength = data.length || 0;
  const nestedClass = nested ? " nested-keys-table " : "";
  // if(!dataLength) '<div></div>';
  return (
    <div
      className={`metric-key-nested-goals-wrapper ${
        nested ? " nested-keys-wrapper " : ""
      }`}
    >
      {data.map((item, index) => (
        <div key={`metric_key_nested_goal_${index}`}>
          <div className="view-table metric-key-nested-goals-table">
            <div className="view-table-col md-nested-goals-perc-col">
              <div
                className="md-nested-achive-text"
                style={{ color: item.goal_progress_color }}
              >
                {item.progress_text}
              </div>
            </div>
            <div className="view-table-col md-nested-goals-name-col">
              <div className="md-nested-goal-name">{item.goal}</div>
              <div className="md-nested-goal-subtitle">
                <span className="md-nested-goal-owner">
                  {item.ownerName +
                    (typeof item.teamName !== "undefined"
                      ? `: ${item.teamName}`
                      : "")}
                </span>
                <span className="md-nested-goal-date">{item.achieve_by}</span>
              </div>
            </div>
          </div>
          {typeof item.metrics !== "undefined" && item.metrics.length ? (
            <MetricKeyNestedKeysComp
              data={item.metrics}
              nested="1"
              handlers={handlers}
              t={t}
            />
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
};

/**
 * @component MetricKeyNestedKeysComp
 * @param {*} param0
 */
const MetricKeyNestedKeysComp = ({ data = [], nested = 0, handlers = {}, t }) => {
  const dataLength = data.length || 0;
  const nestedClass = nested ? " nested-keys-table " : "";
  if (!dataLength) return;
  return (
    <div
      className={`metric-key-nested-keys-wrapper ${
        nested ? " nested-keys-wrapper " : ""
      }`}
    >
      {data.map((item, index) => (
        <div key={`metric_key_nested_keys_wrapper_${index}`}>
          <div
            className={`view-table metric-key-nested-keys-table ${nestedClass}`}
          >
            <div className="view-table-row">
              <div className="view-table-col md-nested-keys-perc-col">
                <div
                  className=""
                  style={{
                    borderLeft: `3px solid ${item.metric_progress_color}`
                  }}
                >
                  <span
                    className="md-keys-achive-target"
                    style={{ color: item.metric_progress_color }}
                  >
                    {item.achieve_target}
                  </span>
                  {item.targetDisplay ? (
                    <span className="md-keys-total-target">
                      {` of ${item.total_target}`}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="view-table-col md-nested-keys-name-col">
                {item.name}
              </div>
            </div>
          </div>
          {typeof item.goals !== "undefined" && item.goals.length ? (
            <MetricKeyNestedGoalsComp
              data={item.goals}
              nested="1"
              handlers={handlers}
              t={t}
            />
          ) : (
            ""
          )}
          {typeof item.metrics !== "undefined" && item.metrics.length ? (
            <MetricKeyNestedKeysComp
              data={item.metrics}
              nested="1"
              handlers={handlers}
              t={t}
            />
          ) : (
            ""
          )}
          {typeof item.metricData !== "undefined" && item.metricData.length ? (
            <MetricDataListComp
              data={item.metricData}
              nested="1"
              handlers={handlers}
              t={t}
            />
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
};

/**
 * @component MetricKeyResultsComp
 */
class MetricKeyResultsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrintPage: 0
    };
    this.showLikes = this.showLikes.bind(this);
    this.hideLikes = this.hideLikes.bind(this);
  }

  componentDidMount() {
    const data = this.props.data || {};
    this.state.isPrintPage =
      typeof data.fromSource !== "undefined" && data.fromSource == "print"
        ? 1
        : 0;
    // if(!this.state.isPrintPage)
    // this.hideLikes();
  }

  showLikes(e, item) {
    if (!this.state.isPrintPage) {
      const { id } = item;
      $(`#wb-likes-theme-${id}`).show();
    }
  }

  hideLikes(e, item) {
    if (!this.state.isPrintPage) {
      const { id } = item;
      const likescount =
        $(`#wb-likes-theme-${id}`)
          .find(".wb-like-count")
          .attr("data-count") || 0;
      if (likescount == 0) {
        $(`#wb-likes-theme-${id}`).hide();
      }
    }
  }

  render() {
    const { t } = this.props;
    const data = this.props.data || {};
    const dataLength = Object.keys(data).length;
    const handlers = {
      showLikes: this.showLikes,
      hideLikes: this.hideLikes
    };
    const store = {};
    if (typeof data.fromSource !== "undefined") {
      store.fromSource = data.fromSource;
      store.orgLogo = data.orgLogo;
    }
    return (
      <div>
        <MetricDataHeaderComp data={data} store={store} t={t}/>
        {dataLength &&
        (data.source == "1" ||
          data.source == "5" ||
          data.source == "10" ||
          data.source == "12" ||
          data.source == "13" ||
          data.source == "14" ||
          data.source == "3") &&
        typeof data.metricData !== "undefined" &&
        data.metricData.length ? (
          <MetricDataListComp
            data={data.metricData}
            store={store}
            handlers={handlers}
            source={data.source}
            t={t}
          />
        ) : (
          ""
        )}
        {dataLength &&
        data.source == "7" &&
        typeof data.goals !== "undefined" &&
        data.goals.length ? (
          <MetricKeyNestedGoalsComp data={data.goals} handlers={handlers} t={t}/>
        ) : (
          ""
        )}

        {dataLength &&
        data.source == "3" &&
        typeof data.metrics !== "undefined" &&
        data.metrics.length ? (
          <MetricKeyNestedKeysComp data={data.metrics} handlers={handlers} t={t}/>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default hot(withTranslation()(MetricKeyResultsComp));